(ns kyber.subscriptions.pdf-viewer
  (:require [re-frame.core :as re-frame]))

(defn- calculate-total-search-results
  [{:keys [search-results] :as pdf-viewer}]
  (assoc pdf-viewer
         :total-search-results
         (reduce (fn [total page-results]
                   (+ total (count page-results)))
                 0
                 search-results)))

(defn get-pdf-viewer
  [{:keys [pdf-viewer]} _]
  (calculate-total-search-results pdf-viewer))

(re-frame/reg-sub :pdf-viewer get-pdf-viewer)

(defn get-pdf-viewer-attributes
  [{:keys [pdftron-instances]} [_ {:keys [viewer-key]}]]
  (get pdftron-instances viewer-key))

(re-frame/reg-sub :pdftron-viewer/get-viewer-attributes get-pdf-viewer-attributes)

(defn get-active-tool
  [{:keys [pdftron-instances]} [_ {:keys [viewer-key]}]]
  (get-in pdftron-instances [viewer-key :active-tool]))

(re-frame/reg-sub :pdftron-viewer/get-active-tool get-active-tool)

(defn get-visible-pages
  [{:keys [pdftron-instances]} [_ {:keys [viewer-key]}]]
  (get-in pdftron-instances [viewer-key :visible-pages]))

(re-frame/reg-sub :pdftron-viewer/get-visible-pages get-visible-pages)


(defn get-annotation-layer-loaded
  [{:keys [pdftron-instances]} [_ {:keys [viewer-key]}]]
  (get-in pdftron-instances [viewer-key :annotation-layer-loaded]))

(re-frame/reg-sub :pdftron-viewer/get-annotation-layer-loaded get-annotation-layer-loaded)
